module.exports = __webpack_public_path__ + "img/responsibility_2.90a87e88.jpg";